import { colors } from '../../../../../packages';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
  drawer: {
    '& .MuiPaper-root': {
      maxWidth: '560px !important',
    },
    '& .drawerBody': {
      padding: 0,
    },
  },
  wrapper: {
    flex: 1,
    flexDirection: 'column',
  },
  header: {
    position: 'relative',
    padding: 24,
    borderBottom: `1px solid ${colors.neutral100}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  headTitle: {
    fontSize: 24,
    lineHeight: '32px',
    margin: 0,
  },
  content: {
    height: 'calc(100vh - 200px)',
    overflowY: 'auto',
    transition: 'height 300ms linear',
  },
  showFooter: {
    height: 'calc(100vh - 290px)',
  },
  checkIcon: {
    textAlign: 'center',
    paddingRight: 20,
  },
  footer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 80,
    padding: 16,
    borderTop: `1px solid ${colors.neutral100}`,
    '& button': {
      height: 48,
    },
  },
  closeBtn: {
    minWidth: 'auto',
    '& svg': {
      width: 24,
    },
  },
  member: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
  },
  info: {
    display: 'flex',
    flexDirection: 'column',
    gap: 0,
  },
  table: {
    backgroundColor: colors.white,
  },
  id: {
    fontFamily: 'Manrope',
    fontWeight: 600,
    fontSize: 14,
    lineHeight: '20px',
    color: colors.neutral900,
  },
  name: {
    fontFamily: 'Manrope',
    fontWeight: 500,
    fontSize: 14,
    lineHeight: '20px',
    color: colors.neutral600,
  },
  rowWapper: {
    color: colors.neutral900,
    padding: '15px 10px',
    fontSize: 14,
    fontFamily: 'Manrope',
    fontWeight: 500,
    borderBottom: `1px solid ${colors.neutral100}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: colors.neutral100,
    },
  },
  tableContainer: {
    height: '100%',
    overflowY: 'auto',
  },
  btnContainer: {
    display: 'flex',
    justifyContent: 'center',
    padding: 16,
  },
  memberWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%',
  },
  inputSearch: {
    height: 56,
    padding: 0,
    width: '100%',
    margin: '16px 0',
    '& fieldset': {
      borderRadius: '4px !important',
    },
  },
});
